import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMoviesByIds } from '@/lib/data';

const featuredIds = ['30', '1', '18', '4', '3'];

export default function HeroCarousel() {
  const featured = getMoviesByIds(featuredIds);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % featured.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [featured.length]);

  const go = (dir: number) => {
    setIndex((i) => (i + dir + featured.length) % featured.length);
  };

  return (
    <section className="relative w-full">
      <div className="relative w-full h-[440px] md:h-[560px] overflow-hidden rounded-lg bg-primary-950">
        {featured.map((m, i) => (
          <div
            key={m.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? 'opacity-100 z-10' : 'opacity-0 z-0'
            }`}
            aria-hidden={i !== index}
          >
            <img
              src={m.cover}
              alt={`${m.title} 焦点推荐`}
              title={`${m.title} · 韩国剧情电影专题`}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/95 via-primary-950/55 to-primary-950/25" />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/80 via-transparent to-transparent" />

            {i === index && (
              <div className="absolute inset-0 flex items-end">
                <div className="w-full px-6 md:px-12 pb-10 md:pb-14">
                  <div className="max-w-2xl animate-fade-up">
                    <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 font-label text-[11px] font-bold uppercase tracking-wider text-primary-950">
                      <i className="ri-flashlight-fill" aria-hidden="true" />
                      本期焦点 · {m.year}
                    </span>
                    <h2 className="mt-4 font-heading text-3xl md:text-5xl font-extrabold text-background-50 leading-tight">
                      {m.title}
                    </h2>
                    <p className="mt-2 font-label text-sm text-background-200/85">
                      {m.titleEn} · {m.director} 导演 · {m.genres.join(' / ')}
                    </p>
                    <p className="mt-4 max-w-xl text-sm md:text-base leading-relaxed text-background-100/90">
                      {m.summary}
                    </p>
                    <div className="mt-6 flex flex-wrap gap-3">
                      <Link
                        to={`/detail/${m.id}`}
                        className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-accent-500 font-label text-sm font-semibold text-primary-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        <i className="ri-play-circle-line text-lg" aria-hidden="true" />
                        查看影片详情
                      </Link>
                      <Link
                        to="/category"
                        className="inline-flex items-center gap-2 h-11 px-5 rounded-md border border-background-100/40 bg-background-50/10 font-label text-sm font-semibold text-background-50 hover:bg-background-50/20 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        浏览全部影片
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ))}

        {/* Controls */}
        <button
          type="button"
          onClick={() => go(-1)}
          className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full border border-background-100/30 bg-primary-950/40 text-background-50 hover:bg-accent-500 hover:text-primary-950 hover:border-accent-500 transition-colors cursor-pointer"
          aria-label="上一张"
        >
          <i className="ri-arrow-left-s-line text-2xl" aria-hidden="true" />
        </button>
        <button
          type="button"
          onClick={() => go(1)}
          className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 z-20 w-9 h-9 md:w-11 md:h-11 flex items-center justify-center rounded-full border border-background-100/30 bg-primary-950/40 text-background-50 hover:bg-accent-500 hover:text-primary-950 hover:border-accent-500 transition-colors cursor-pointer"
          aria-label="下一张"
        >
          <i className="ri-arrow-right-s-line text-2xl" aria-hidden="true" />
        </button>

        <div className="absolute bottom-5 right-5 md:right-10 z-20 flex items-center gap-2">
          {featured.map((m, i) => (
            <button
              key={m.id}
              type="button"
              onClick={() => setIndex(i)}
              className={`h-1.5 rounded-full transition-all cursor-pointer ${
                i === index ? 'w-7 bg-accent-500' : 'w-3 bg-background-100/50 hover:bg-background-100/80'
              }`}
              aria-label={`切换到第 ${i + 1} 张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}